export const REDUX_STORE_HOME = 'activity_report'

export enum ActivityType {
  ARTICLE_ACTIVITY = 'article-activity',
  IMAGE_ACTIVITY = 'image-activity',
  SCHEDULE_HISTORY = 'schedule-history',
  SOURCE_HISTORY = 'source-history'
}

export const ACTIVITY_TYPE_OPTIONS = {
  [ActivityType.ARTICLE_ACTIVITY]: 'Article Activity',
  [ActivityType.IMAGE_ACTIVITY]: 'Image Activity',
  [ActivityType.SCHEDULE_HISTORY]: 'Schedule History',
  [ActivityType.SOURCE_HISTORY]: 'Source History'
}
